import * as React from 'react'
import { BLOCKS } from '@contentful/rich-text-types'

export const htmlOptions = ({ raw }) => {
  const { links } = JSON.parse(raw)
  const assetMap = {}

  for (const {
    sys: { id },
    url,
    title,
    contentType,
  } of links?.assets?.block || []) {
    if (contentType.startsWith('image/')) {
      assetMap[id] = {
        url,
        title,
      }
    }
  }

  return {
    renderNode: {
      [BLOCKS.HEADING_2]: (node, children) => (
        <h2
          style={{
            marginTop: 8,
            marginBottom: 4,
            fontSize: 24,
            fontWeight: 'semibold',
          }}
        >
          {children}
        </h2>
      ),
      [BLOCKS.PARAGRAPH]: (node, children) => (
        <p style={{ marginBottom: 4 }}>{children}</p>
      ),
      [BLOCKS.EMBEDDED_ASSET]: node => {
        const {
          data: {
            target: {
              sys: { id },
            },
          },
        } = node
        const image = assetMap[id]
        if (!image) {
          return ''
        }
        return `<img src="${image.url}" alt="${image.title}"/>`
      },
    },
  }
}
